module.exports = __webpack_public_path__ + "img/1-2.a2f3329e.svg";